import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "core/common/config/locales";

const gridLocation = 'timeSheetReport';


@observer
export default class TimeSheetReport extends PageAncestor<PageProps, undefined> {

  static module = MODULE.humanresource;
  static title = loc.i18n`Time sheets`;
  static icon = 'user-circle-o';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("TimeSheetReport#fetchData(%s)", gridLocation);

    return gridService.fetchGrids(gridLocation)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(gridLocation);
      });
  }







  render() {
    let {params, query} = this.props;


    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(gridLocation)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}/>
    );
  }


}



// WEBPACK FOOTER //
// ./src/humanresource/page/timeSheetReport.tsx